










import infoRowsBlock from '@/components/Ui/ActiveInfoPage/Blocks/infoRows.vue'
import Vue from 'vue'
import UiTag from '@/components/Ui/Tag/Tag.vue'
import UiProgress from '@/components/Ui/Progress/Progress.vue'
import statusComponent from '@/components/Newsletters/status.vue'
import Mailing from '@/models/mailing/mailing'
import {MAILING_STATUS_PROGRESS} from '@/constants';

export default Vue.extend({
  name: 'mailingPageStatusBlock',
  props: {
    scope: {} as () => {mailing: Mailing},
    options: {}
  },
  components: {
    infoRowsBlock,
    UiTag,
    UiProgress,
    statusComponent
  },
  data () {
    return {
      MAILING_STATUS_PROGRESS
    }
  },
  computed: {
    sendProgress (): number {
      return this.scope.mailing.getSendProgress();
    },
    isProgress (): boolean {
      return this.scope.mailing.getStatus() === MAILING_STATUS_PROGRESS
    }
  }
})
